import React from 'react';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { Button } from 'tradera/components/atoms/button/button';
import {
    StickyButtonPortal,
    StickyButtonPosition
} from '../sticky-button/sticky-button';
import { FloatingActionButtonPortal } from '../floating-action-button/floating-action-button';
import { useScrollPosition } from 'tradera/hooks/use-scroll-position';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { GtmService } from 'tradera/services/google-tagmanager-service';
import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';
import uiActions from 'tradera/state/ui/actions';
import PlusIcon from 'tradera/blueprint/theme/icons2/plus-outline.svg?jsx';
import WriteIcon from 'tradera/blueprint/theme/icons2/pen-write.svg?jsx';

export const NewListingButton = () => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const { isLoggedIn } = useAppSelector((state) => state.member);
    const dispatch = useAppDispatch();

    const linkUrl = toLocalizedUrl('/selling/new');

    const handleClick = (
        buttonVariant: string,
        event?: React.MouseEvent<HTMLElement>
    ) => {
        GtmService.trackAction(
            'StartPage',
            'New listing button',
            buttonVariant
        );
        if (!isLoggedIn) {
            event?.preventDefault();
            dispatch(uiActions.signIn({ redirectUrl: linkUrl }));
        }
    };

    const scrollPosition = useScrollPosition();

    const isHidden = scrollPosition > 150;

    const experimentVariant = useFeatureValue('tgl-404-new-listing-fab', 0);

    if (experimentVariant === 1) {
        return (
            <StickyButtonPortal
                position={StickyButtonPosition.Left}
                shadow
                hideOnScroll={false}
                isHidden={isHidden}>
                <Button
                    href={linkUrl}
                    onClick={(e) => handleClick('Sticky', e)}
                    theme="highlight"
                    size="xs"
                    brandedText
                    className="font-weight-bold">
                    {t('siteHeader_newListing')}
                </Button>
            </StickyButtonPortal>
        );
    } else if (experimentVariant === 2) {
        return (
            <FloatingActionButtonPortal
                hideOnScroll={false}
                isHidden={isHidden}>
                <Button
                    href={linkUrl}
                    onClick={(e) => handleClick('Plus icon', e)}
                    theme="highlight"
                    className="d-flex justify-content-center shadow"
                    round
                    size="lg"
                    icon={
                        <PlusIcon
                            className="icon"
                            style={{ height: '28px', width: '28px' }}
                        />
                    }
                />
            </FloatingActionButtonPortal>
        );
    } else if (experimentVariant === 3) {
        return (
            <FloatingActionButtonPortal
                hideOnScroll={false}
                isHidden={isHidden}>
                <Button
                    href={linkUrl}
                    onClick={(e) => handleClick('Write icon', e)}
                    theme="highlight"
                    className="d-flex justify-content-center shadow"
                    round
                    size="lg"
                    icon={
                        <WriteIcon
                            className="icon"
                            style={{ height: '28px', width: '28px' }}
                        />
                    }
                />
            </FloatingActionButtonPortal>
        );
    } else {
        return null;
    }
};
